/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */
import { Component, createRef, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Row, Col, Button } from 'react-bootstrap';
import { SalesService, LocationService } from 'shared/services';
import moment from 'moment';
import { image_thumbnail } from 'shared/images/images';
import Helmet from 'react-helmet';
import store from 'features/store';
import { disablePreviousState } from 'shared/settings/stateMaintain';
import { isAuthorized } from 'shared/settings/auth';

import { ADSENSE, LOCATION_MILES } from 'shared/settings/config';

import './SalesListForLocation.scss';
import { addDataLayer } from 'shared/utils/utils';
import { Adsense } from 'shared/utils/Adsense';
import SaleCard from '../HOC/SaleCard';
import { HeartPlusIcon } from 'shared/assets/icons';
import { Pagination } from '../HOC/Pagination';
import { Loader } from 'shared/hoc/loader/Loader';
import { SALE_LIST_TYPE, SaleListHoc } from '../HOC/SaleListHoc';
import { Breadcrumbs } from 'shared/hoc/breadcrumbs/Breadcrumbs';
import { BREADCRUMB_TYPE_CONFIG } from 'shared/hoc/breadcrumbs/config';
const pageSize = 4
/**
@Author Karthik

@param

@return html code for sales list based on location
**/

class SalesListForLocationn extends Component {
    constructor(props) {
        super(props);
        this.headerContentRef = createRef();
        this.state = {
            pageLoading: true,
            innerWidth: window.innerWidth, /* To handle responsive */
            locationDetails: {},
            locationImageList: [],
            nextList: null,
            salesList: [],
            loaderForMore: false,
            noRecordFound: false,
            locationInProgress: {},
            favoriteLocations: [],
            pageTitle: "CTBids",
            pageDescription: "CTBids buyers web app",
            h1Tag: "",
            h2Tag: "",
            footerData: {},
            locationNotFound: false,
            emptyTag: "",
            zipcode: '',
            estateSaleList: [],
            locationList: [],
            locationTitle: '',
            locationLoading: true,
            inactiveSale: true,
            pageSet: {},
        }
        this.locationId = null;
    }
    componentDidMount() {
        this.windowWidthGet();
        window.addEventListener('resize', this.windowWidthGet);
        this.getLocationDetails();
        store.dispatch({ type: 'SET_PREVIOUS_PATH', payload: { component: "SaleListForLocation" } });
        disablePreviousState();
        if (isAuthorized()) {
            this.getFavoriteLocation();
        }
    }

    componentDidUpdate(prevProps) {
        if (JSON.stringify(prevProps.user) !== JSON.stringify(this.props.user)) {
            if (isAuthorized()) {
                this.getFavoriteLocation();
            } else {
                this.setState({
                    favoriteLocations: []
                });
            }
        }
        window.addEventListener('resize', this.windowWidthGet);
    }

    getLocationDetails = () => {
        const locationCode = this.props.match.params.locationcode;
        const locationStateCode = this.props.match.params.locationstatecode;
        const postData = {
            "sort": [{ "field": "title", "direction": "asc" }],
            "page": { 'size': pageSize },
            "filter": [{ "field": "locationstatecode", "value": locationStateCode, "op": "=", "join": "AND" }]
        };
        if (locationCode) {
            postData.filter.push({ "field": "locationcode", "value": locationCode, "op": "=", "join": "AND" });
        } else {
            postData.filter.push({ "field": "locationcode", "value": null, "op": "IS", "join": "AND" });
        }
        LocationService.getLocationList(postData).then(res => {
            const data = res.data.data[0];
            const zipcode = data.zip;
            this.setState({
                zipcode: zipcode,
                locationDetails: data
            })

            if (data) {
                this.locationId = data.id;
                this.getLocationSeoList(data.id);
                this.getLocationSaleList(data.id, zipcode);
                this.getLocationImageList(data.id);
            } else {
                this.locationNotFound();
            }
        }).catch(error => {
            this.locationNotFound();
        });
    }

    locationNotFound = () => {
        const locationCode = this.props.match.params.locationcode;
        const locationStateCode = this.props.match.params.locationstatecode;
        const postData = {
            "sort": [{ "field": "title", "direction": "asc" }],
            "page": { 'size': pageSize },
            "field": ["title", "zip"],
            "filter": [
                { "field": "locationstatecode", "value": locationStateCode, "op": "=", "join": "AND" },
                { "field": "miles", "value": LOCATION_MILES, "op": "=", "join": "AND" },
            ]
        }
        if (locationCode) {
            postData.filter.push({ "field": "locationcode", "value": locationCode, "op": "=", "join": "AND" });
        } else {
            postData.filter.push({ "field": "locationcode", "value": null, "op": "IS", "join": "AND" });
        }

        LocationService.getInactiveLocationList(postData).then(res => {
            const locationData = res.data.data;
            const zipcode = locationData[0].zip
            if (locationData) {
                this.getTwoDaysSaleDetails(zipcode);
            } else {
                this.props.history.push("/");
            }
        })
            .catch(error => {
                this.props.history.push("/");
            });


        this.setState({
            locationNotFound: true,
            // pageLoading: false
        });
    }

    getInactiveLocationData = () => {
        const locationCode = this.props.match.params.locationcode;
        const locationStateCode = this.props.match.params.locationstatecode;
        const postData = {
            "sort": [{ "field": "title", "direction": "asc" }],
            "page": { 'size': pageSize },
            "field": ["title", "zip"],
            "filter": [
                { "field": "locationstatecode", "value": locationStateCode, "op": "=", "join": "AND" },
                { "field": "miles", "value": LOCATION_MILES, "op": "=", "join": "AND" },
            ]
        }
        if (locationCode) {
            postData.filter.push({ "field": "locationcode", "value": locationCode, "op": "=", "join": "AND" });
        }
        LocationService.getInactiveLocationList(postData).then(res => {
            const locationData = res.data.data;
            const zipcode = locationData[0].zip;
            this.getTwoDaysSaleDetails(zipcode);
        }).catch(error => {
            this.props.history.push("/");
        })
    }

    /* Called when resize the screen */
    windowWidthGet = () => {
        this.setState({
            innerWidth: window.innerWidth
        });
    }

    getLocationSeoList = (locationid) => {
        const seoData = {
            "filter": [
                {
                    "field": "locationid",
                    "value": locationid,
                    "op": "=",
                    "join": "AND"
                }
            ]
        };

        LocationService.SEOLocationList(seoData).then(res => {
            const data = res.data.data[0];
            if (data) {
                const details = JSON.parse(data.textcontent);
                this.setState({
                    pageDescription: details.metadescription,
                    pageTitle: details.pagetitle,
                    h1Tag: details.h1tag,
                    h2Tag: details.h2tag,
                    footerData: details.footercopy
                })
            }
        }).catch(error => error);
    }

    getLocationSaleList = (locationid, zipcode, page={}) => {
        const saleList = {
            "sort": [{ "field": "endtimeutc", "direction": "asc" }],
            "field": ["id", "title", "city", "state", "zipcode", "starttime", "endtime", "itemcount", "status", "provenance", "timezoneid", "timezonename", "endtimeutc", "itemimageurl", "url", "staticcoverimage", "staticinsertimage", "saleitemreceiptmethod", "locationid", "locationtitle"],
            "filter": [
                { "field": "locationid", "value": locationid ? locationid : this.locationId, "op": "=", "join": "AND" },
                { "field": "status", "value": "Started", "op": "=", "join": "AND" }
            ],
            "page": { "size": pageSize, ...page }
        };
        SalesService.getSalesList(saleList).then(
            endingSoon => {
                let temp = [];
                temp = endingSoon.data.data;
                let salesData = endingSoon.data.data;
                if (temp.length > 0) {
                    const imageListData = { "filter": [{ "field": "saleid", "value": [temp.map(elem => { return elem.id; })], "op": "IN", "join": "AND" }] };
                    SalesService.getSaleImagesList(imageListData).then(
                        saleImageList => {
                            temp.forEach((elem) => {
                                let imageData = saleImageList.data.data.find((image) => { return image.saleid == elem.id; })
                                if (typeof imageData != "undefined") {
                                    let imageUrlData = imageData.saleimageurl || imageData.locationimageurl;
                                    if (typeof imageUrlData === 'string') {
                                        elem.saleimageurl = imageUrlData.split(',').find(img => { return img.includes('profile#*#'); })?.split("#*#")[1];
                                    }
                                }
                            })
                            this.setState({
                                salesList: salesData,
                                pageLoading: false,
                                locationLoading: false,
                                pageSet: endingSoon.data.page
                            });
                        }
                    ).catch((error) => {
                        // TODO: Error message handle
                    });
                } else {
                    this.getTwoDaysSaleDetails(zipcode);
                    this.setState({
                        pageLoading: false,
                        locationLoading: false
                    });
                }
            }
        ).catch((error) => {
            // TODO: Error message handle
            this.setState({
                noRecordFound: true,
                pageLoading: false,
                locationLoading: false
            });
        });
    }

    getLocationImageList = (locationid) => {
        const locationImageData = { "filter": [{ "field": "locationid", "value": locationid, "op": "=", "join": "AND" }] };
        LocationService.getLocationImagesList(locationImageData).then(
            locationImage => {
                this.setState({
                    locationImageList: locationImage.data.data,
                    pageLoading: false
                });
            }
        ).catch((error) => {
            this.setState({
                noRecordFound: true,
                pageLoading: false
            });
        });
    }

    getFavoriteLocation = () => {
        // TO get the FavoriteLocation list
        const favoritePostData = {
            "sort": [{ "field": "id", "direction": "asc" }],
            "field": ["id", "locationid", "buyerid"]
        };
        if (isAuthorized()) {
            LocationService.getFavoriteLocation(favoritePostData).then(favoriteLocationData => {
                const favoriteLocationDataTemp = favoriteLocationData.data.data;
                this.setState({
                    favoriteLocations: favoriteLocationDataTemp
                });
            }).catch(error => {
                // TODO: Error message handle                   
                this.setState({
                    noDataFound: true,
                    pageLoading: false,
                });

            });
        }
    }

    navigate = (sale) => {
        this.props.history.push(`/estate-sale/${sale.id}`);
    }
    back = () => {
        // enablePreviousState();
        this.props.history.goBack();
        // this.props.history.push(`/locations`);
    }
    openInNewTab = (url) => {
        if (url) {
            const reformat = url.includes('http') ? url : 'http://' + url;
            const newWindow = window.open(reformat, '_blank', 'noopener,noreferrer');
            if (newWindow) newWindow.opener = null;
        }
        let dataLayerData = {
            'event': 'location_visit',
            'title': this.state.locationDetails.title
        }
        addDataLayer(dataLayerData);
    }
    removeSale = (index) => {
        this.setState({
            refreshScreen: true
        }, () => {
            const temp = this.state.salesList;
            temp.splice(index, 1);
            this.setState({
                salesList: temp
            });
            setInterval(() => {
                this.setState({
                    refreshScreen: false
                });
            }, 500)
        });
    }
    componentWillUnmount() {
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state, callback) => {
            return;
        };
    }
    moreSaleLocations = () => {
        this.props.history.push(`/locations`);
    }
    /** ************************************************** */
    /** Favorite Location Button on Each Location - Starts*/
    /** ************************************************** */
    isFavoriteLocation = (location) => {
        return this.state.favoriteLocations.findIndex(x => x.locationid === location.id) > -1;
    }
    signInOpen = (flag) => {
        store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: true, mode: flag } });
    }



    getTwoDaysSaleDetails = (zipcode) => {
        const end = moment.utc().add(48, 'hours').format("YYYY-MM-DD HH:mm:ss")
        const twoDaysale = {
            "page": { "size": pageSize },
            "sort": [{ "field": "endtimeutc", "direction": "asc" }],
            "field": ["id", "title", "city", "state", "zipcode", "starttime", "endtime", "itemcount", "status", "provenance", "timezoneid", "timezonename", "endtimeutc", "itemimageurl", "url", "staticcoverimage", "staticinsertimage", "saleitemreceiptmethod"],
            "filter": [
                { "field": "status", "value": "Started", "op": "=", "join": "AND" },
                { "field": "zipcode", "value": zipcode, "op": "=", "join": "AND" },
                { "field": "miles", "value": LOCATION_MILES, "op": "=", "join": "AND" },
                { "field": "endtimeutc", "value": end, "op": "<=", "join": "AND" },
                { "field": "isdeleted", "value": 0, "op": "=", "join": "AND" }
            ]
        }
        SalesService.getSalesList(twoDaysale).then(
            res => {
                const data = res.data.data
                this.setState({
                    estateSaleList: data,
                    pageLoading: false,
                    pageSet: res.data.page
                })
            }
        )
    }

    searchPage() {
        this.props.history.push('/explore')
    }

    /** Favorite Location Click Event */
    favoriteLocation = (event, location) => {
        event.stopPropagation();
        event.preventDefault();
        const value = event.target.checked;
        if (isAuthorized()) {
            this.setState({
                locationInProgress: {
                    ...this.state.locationInProgress,
                    [location.id]: true
                }
            }, () => {
                disablePreviousState();
                if (value) {
                    this.addFavoriteLocation(location);
                } else {
                    this.removeFavoriteLocation(location);
                }
            });
        } else {
            this.signInOpen('Sign-In');
        }
    }
    /** If Favorite Location Button is Checked */
    addFavoriteLocation = (location) => {
        const postData = { "data": { "locationid": location.id } };
        LocationService.addFavoriteLocation(postData).then(res => {
            const favoriteLocations = this.state.favoriteLocations;
            const data = res.data.data[0];
            data['buyerid'] = this.props.user.id;
            favoriteLocations.push(data);
            this.setState({
                favoriteLocations,
                locationInProgress: {
                    ...this.state.locationInProgress,
                    [location.id]: false
                }
            })
        }).catch(error => {
            this.setState({
                locationInProgress: {
                    ...this.state.locationInProgress,
                    [location.id]: false
                }
            });
        });
    }
    getProfileImage = (location) => {
        const locationImage = {};
        if (location.imageurl) {
            const image = location.imageurl.split(',');
            image.forEach(x => {
                const temp = x.split('#*#');
                locationImage[temp[0]] = temp[1];
            });
        }
        return locationImage.profile ? locationImage.profile : image_thumbnail;
    }

    navigateLocationList = (event, location) => {
        let url = ''
        let classList = [...event?.target?.classList];
        const check = classList.length > 0 && (classList.includes('custom-control-label') || classList.includes('custom-control-input'));
        if (!check) {
            url = location.locationcode ? `/estate-sales/${location.locationstatecode}/${location.locationcode}` : `/estate-sales/${location.locationstatecode}`;
            this.props.history.push(url);
            window.location.reload()
        }
    }

    /** If Favorite Location Button is UnChecked */
    removeFavoriteLocation = (location) => {
        const favoriteLocations = this.state.favoriteLocations;
        const locationData = favoriteLocations.findIndex(x => x.locationid === location.id);
        const postData = { "data": { "locationIds": [{ "id": location.id }] } };
        LocationService.deleteFavoriteLocation(postData).then(res => {
            favoriteLocations.splice(locationData, 1);
            this.setState({
                favoriteLocations,
                locationInProgress: {
                    ...this.state.locationInProgress,
                    [location.id]: false
                }
            });
        }).catch(error => {
            this.setState({
                locationInProgress: {
                    ...this.state.locationInProgress,
                    [location.id]: false
                }
            });
        });
    }

    /** ************************************************** */
    /** Favorite Location Button on Each Location - Ends*/
    /** ************************************************** */
    render() {
        return (
            <div className="sales-list-main w-100">
                <Helmet>
                    <title>{this.state.pageTitle}</title>
                    <meta name='description' content={this.state.pageDescription} />
                    <meta name="google-site-verification" content="PPiTWW_2xWSo19mPTsAyR2w2L4blIGf5dTyAmvknUrs" />
                    <link rel="canonical" href={`https://ctbids.com${this.props.match.url}`} />
                </Helmet>
                <div className="d-none">
                    {
                        this.state.h1Tag ?
                            <h1>{this.state.h1Tag}</h1>
                            : ''
                    }
                    {
                        this.state.h2Tag ?
                            <h2>{this.state.h2Tag}</h2>
                            : ''
                    }
                </div>
                {
                    this.state.pageLoading || this.state.locationLoading ?
                        <div className="loader d-flex align-items-center justify-content-center">
                            <img src={`${process.env.PUBLIC_URL}/static/icons/table/loader.gif`} className="loader-icon" alt="loader-icon"></img>
                        </div> :
                        this.state.noRecordFound ? <div className="no-data-found mt-3 h-100 d-flex flex-column align-items-center justify-content-center">
                            <div className="text-center no-data-search-icon">
                                <i className="fas fa-search fa-3x"></i>
                            </div>
                            <div className="text-center h4 text-bold">
                                No results found
                            </div>
                            <div className="text-center text-muted h5">
                                We couldn't find what you're looking for.
                            </div>
                        </div> :
                            <>
                                <div className="d-flex align-items-center clickable mt-3 bread-crumb-resp" style={{ marginLeft: '50px', fontSize: "18px" }}>
                                    <span className="headnavbar" onClick={() => { this.props.history.push("/") }}>Home / </span><span className="headnavbar" onClick={this.back}> Locations </span> <span className="subnavbar"> / {this.state.locationDetails.title}</span>
                                </div>
                                <div className="sales-list d-flex w-100 pd-5 location-card-resp">
                                    <div className='mobile-width' style={{ width: "30%" }}>
                                        <div className="borderview-sale">
                                            <div className=" d-flex flex-column align-items-center justify-content-center mt-3">
                                                <text className={`font-weight-bold text-center ${this.state.locationDetails.salecount > 0 ? "text-secondary" : "text-inactive"}`} style={{ fontSize: "20px" }}>{this.state.locationDetails.title}</text>
                                                <text className={`${this.state.locationDetails.salecount > 0 ? "text-secondary" : "text-inactive"}`} style={{ fontSize: "14px" }}>{this.state.locationDetails.state}</text>
                                            </div>
                                            <div className=" d-flex flex-column align-items-center justify-content-center">
                                                <div className="image-container">
                                                    <img className="location-image" src={this.getProfileImage(this.state.locationDetails)} alt="location-image"></img>
                                                </div>
                                            </div>
                                            <div className="my-3">
                                                <div className=" d-flex flex-column align-items-center justify-content-center">
                                                    <text className={`font-weight-bold ${this.state.locationDetails.salecount > 0 ? "text-secondary" : "text-inactive"}`}>{this.state.locationDetails.contactname}</text>
                                                    <text className={`${this.state.locationDetails.salecount > 0 ? "text-secondary" : "text-dimmed"}`}>{this.state.locationDetails.salecount ? this.state.locationDetails.salecount : 0} Active Sale</text>
                                                </div>
                                                <div className=" d-flex flex-column align-items-center justify-content-center my-2">
                                                    <text className="contact"><a href={`tel:+${this.state.locationDetails.phone}`}>{this.state.locationDetails.phone}</a> | <span className="clickable linkview" role={"button"} onClick={() => {
                                                        let url = this.state.locationDetails?.website;
                                                        const reformat = url.includes('http') ? url : 'http://' + url;
                                                        const newWindow = window.open(reformat, '_blank', 'noopener,noreferrer');
                                                        if (newWindow) newWindow.opener = null;
                                                    }}>Visit Website</span></text>
                                                    <text className="contact linkview"><a href={`mailto:${this.state.locationDetails.email}`}>{this.state.locationDetails.email}</a></text>
                                                </div>
                                                <div className="d-flex align-items-center gap3  ">
                                                    <Button className='btn-secondary rounded border-secondary border-2' onClick={(event) => { this.favoriteLocation(event, this.state.locationDetails) }}
                                                        style={{ border: "1px solid" }} aria-label="heart-icon">{HeartPlusIcon}</Button>
                                                    <Button
                                                        className=' w-100 btn-grey-light  rounded text-bold'
                                                        onClick={() => {
                                                            let url = this.state.locationDetails?.website;
                                                            const reformat = url.includes('http') ? url : 'http://' + url;
                                                            const newWindow = window.open(reformat, '_blank', 'noopener,noreferrer');
                                                            if (newWindow) newWindow.opener = null;
                                                        }}
                                                    >View Website</Button>
                                                </div>
                                            </div>
                                        </div>
                                        {ADSENSE.ENABLE ? <Adsense googleAdCenter slotId={ADSENSE.ITEM_VIEW.slotId} /> : ""}
                                    </div>

                                    <div className='mobile-width' style={{ width: "70%" }}>
                                        <div className="content-body d-flex align-items-center justify-content-center flex-column mobile-mg-top">
                                            <h1 className='font-weight-bold text-center'>Estate sales at {this.state.locationDetails.title}</h1>
                                            <div className="text-center mt-3" style={{ fontSize: "18px" }}>{this.state.locationDetails.description}</div>
                                            <div className="w-100">
                                                {this.state.refreshScreen ? null :
                                                    this.state.salesList?.length !== 0 ?
                                                        <div>
                                                            <div className="d-flex align-items-center justify-content-center mt-5">
                                                                <Row xs={1} sm={1} md={1} lg={2}>
                                                                    {
                                                                        this.state.salesList.map((item, index) =>
                                                                            <Col key={`item_${index + 1}`}>
                                                                                <SaleCard sale={item} {...this.props} navigate={this.navigate} removeSale={() => this.removeSale(index)} saleBoard={true} />
                                                                            </Col>
                                                                        )
                                                                    }
                                                                </Row>
                                                            </div>
                                                            {this.state.salesList.length === 0 ?
                                                                <div className="no-data-found h-80 d-flex flex-column align-items-center justify-content-center">
                                                                    <div className="text-center text-muted h5">
                                                                        No current sales from this Seller. Please check back again soon.
                                                                    </div>
                                                                </div> : null}
                                                        </div> : <div>
                                                            <div className='text-secondary' style={{ marginTop: "3%" }}>
                                                                <p className="text-center mt-5 location-msg" style={{ fontSize: "20px" }}>This location is currently crafting a new and unique collection.</p>
                                                                <div className="text-center location-msg" style={{ fontSize: "20px" }}>Check back for updates!</div>
                                                            </div>
                                                            {this.state.estateSaleList?.length !== 0 ?
                                                                <div style={{ marginTop: '3%', color: "#00263E", fontWeight: "500" }}>
                                                                    <p className="text-center location-msg" style={{ fontSize: "20px" }}>Find a sale closest to you. You're guaranteed to find something you love!</p>
                                                                </div> : ''}
                                                            <Row xs={1} sm={1} md={1} lg={2} className='mt-3'>
                                                                {
                                                                    this.state.estateSaleList.map((item, index) =>
                                                                        <Col key={`item_${index + 1}`}>
                                                                            <SaleCard sale={item} {...this.props} navigate={this.navigate} removeSale={() => this.removeSale(index)} saleBoard={true} />
                                                                        </Col>
                                                                    )
                                                                }
                                                            </Row>
                                                            <div className="d-flex flex-column align-items-center justify-content-center text-center mt-3 mb-3">
                                                                <p className='location-msg'>Looking for something specific?</p>
                                                                <Button variant="secondary" className='mt-3 mb-3' onClick={() => this.searchPage()}>
                                                                    Search
                                                                </Button>
                                                            </div>
                                                        </div>
                                                }
                                            </div>
                                            <Pagination loading={this.state.pageLoading} page={this.state.pageSet} onPageChangeCallback={(page) => {this.getLocationSaleList(this.locationId, this.state.zipcode, page)}} />
                                        </div>
                                        <div>
                                            {ADSENSE.ENABLE ? <Adsense googleAdCenter slotId={ADSENSE.FOOTER.slotId} /> : ""}
                                        </div>
                                    </div>
                                </div>
                            </>
                }
            </div>
        );
    }
}
// export default connect(state => state)(SalesListForLocation);

const SalesListForLocation = (props) => {
    const user = useSelector(state => state.user);

    const [pageLoading, setPageLoading] = useState(true);
    const [locationDetail, setLocationDetail] = useState({});
    const [favLocIds, setFavLocIds] = useState([]);
    const [isFav, setIsFav] = useState(false);
    const [seoDetail, setSeoDetail] = useState({ pageTitle: "CTBids", pageDescription: "CTBids buyers web app" });

    useEffect(() => {
        getRequiredData();
        getFavoriteLocations();
    }, []);

    const getRequiredData = async () => {
        const locationCode = props.match.params.locationcode;
        const locationStateCode = props.match.params.locationstatecode;
        const postData = {
            "sort": [{ "field": "title", "direction": "asc" }],
            "page": { 'size': pageSize },
            "filter": [{ "field": "locationstatecode", "value": locationStateCode, "op": "=", "join": "AND" }]
        };
        if (locationCode) {
            postData.filter.push({ "field": "locationcode", "value": locationCode, "op": "=", "join": "AND" });
        } else {
            postData.filter.push({ "field": "locationcode", "value": null, "op": "IS", "join": "AND" });
        }

        setPageLoading(true);
        LocationService.getLocationList(postData).then(res => {
            const data = res.data.data[0];

            if ( data ) {
                setLocationDetail(data);
                setPageLoading(false);

                getLocationSeoList(data.id).then(response => {
                    if ( response.data.length > 0 && typeof response.data[0].textcontent === 'string' ) {
                        const data = JSON.parse(response.data[0].textcontent);
                        
                        setSeoDetail(prevState => {
                            prevState.pageTitle = data.pagetitle;
                            prevState.pageDescription = data.metadescription;

                            return {...prevState};
                        })   
                    }
                    
                }).catch(error => {

                });
            } else {
                // TODO
                // this.locationNotFound();
            }
        }).catch(error => {
            // this.locationNotFound();
            setPageLoading(false);
        });
    };

    const getLocationSeoList = (locationId) => {
        const seoData = {
            "filter": [
                { "field": "locationid", "value": locationId, "op": "=", "join": "AND" }
            ]
        };

        return new Promise((resolve, reject) => {
            LocationService.SEOLocationList(seoData).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject();
            });
        });
    };

    const getFavoriteLocations = () => {
        const postData = {
            field: ["id", "locationid", "buyerid"],
            filter: [],
            sort: [{ field: "id", direction: "asc" }],
            page: { size: 999 }
        };

        if (user.id) {
            try {
                LocationService.getFavoriteLocation(postData).then(response => {
                    const favLocIds = response.data.data.map(x => x.locationid);
                    setFavLocIds(favLocIds);
                });
            } catch (error) {
                setFavLocIds([]);
            }
        } else {
            setFavLocIds([]);
        }
    };

    const isFavoriteLocation = (location) => {
        return favLocIds.includes(location.id);
    }

    const favoriteLocation = (event, location) => {
        if (isFavoriteLocation(location)) {
            removeFavoriteLocation(location);
            setIsFav(false);
        } else {
            addFavoriteLocation(location);
            setIsFav(true);
        }
    };

    const addFavoriteLocation = (location) => {
        const postData = { data: { locationid: location.id } };

        LocationService.addFavoriteLocation(postData).then(res => {
            getFavoriteLocations();
        }).catch(() => {
        });
    };

    const removeFavoriteLocation = (location) => {
        const postData = { data: { locationIds: [{ id: location.id }] } };

        LocationService.deleteFavoriteLocation(postData).then(() => {
            getFavoriteLocations();
        }).catch(() => {
        });
    };


    const getProfileImage = () => {
        const locationImage = {};
        if (locationDetail.imageurl) {
            const image = locationDetail.imageurl.split(',');
            image.forEach(x => {
                const temp = x.split('#*#');
                locationImage[temp[0]] = temp[1];
            });
        }
        return locationImage.profile ? locationImage.profile : image_thumbnail;
    };

    const openInNewTab = (url) => {
        if (url) {
            const reformat = url.includes('http') ? url : 'http://' + url;
            const newWindow = window.open(reformat, '_blank', 'noopener,noreferrer');
            if (newWindow) newWindow.opener = null;
        }
        let dataLayerData = {
            'event': 'location_visit',
            'title': locationDetail.title
        }
        addDataLayer(dataLayerData);
    }

    return (
        <div className="sale-list-for-location">
            <Helmet>
                <title>{seoDetail.pageTitle}</title>
                <meta name='description' content={seoDetail.pageDescription} />
                <meta name="google-site-verification" content="PPiTWW_2xWSo19mPTsAyR2w2L4blIGf5dTyAmvknUrs" />
                <link rel="canonical" href={`https://ctbids.com${props.match.url}`} />
            </Helmet>

            {
                pageLoading ? 
                <Loader /> : 
                <div className='content'>
                    <Breadcrumbs props={props} type={BREADCRUMB_TYPE_CONFIG.SALE_LIST_FOR_LOCATION} options={{ locationTitle: locationDetail.title }} />

                    <div className='d-flex flex-column flex-md-row flex-grow-1'>
                        <Col xs={12} sm={12} md={4} lg={3}>
                            <div className="location-detail">
                                <div className={`title loc-title ${locationDetail.salecount > 0 ? "text-secondary" : "text-inactive"}`}>{locationDetail.title}</div>
                                <div className={`state ${locationDetail.salecount > 0 ? "text-secondary" : "text-inactive"}`}>{locationDetail.state}</div>
                                <div className="image-container p-4">
                                    <img className='location-image' src={getProfileImage()} alt="location-image"></img>
                                </div>
                                <div className={`contact ${locationDetail.salecount > 0 ? "text-secondary" : "text-inactive"}`}>{locationDetail.contactname}</div>
                                <div className={`${locationDetail.salecount > 0 ? "text-secondary" : "text-dimmed"}`}>{locationDetail.salecount ? locationDetail.salecount : 0} Active Sale</div>
                                {locationDetail?.auctioneerlicense && <div className='text-secondary mt-3' style={{ wordBreak: "break-all" }}>License: {locationDetail?.auctioneerlicense}</div>}
                                <div className='d-flex flex-column align-items-center justify-content-center gap-3 p-3'>
                                    <div className='d-flex gap-1 align-items-center justify-content-center flex-wrap'>
                                        <div>
                                            <a href={`tel:${locationDetail.phone}`}>{locationDetail.phone}</a>
                                        </div>
                                        <div>|</div>
                                        <div className='text-decoration-underline'>
                                            <a href={`mailto:${locationDetail.email}`}>{locationDetail.email}</a>
                                        </div>
                                    </div>
                                    
                                </div>
                                <div className='d-flex w-100 gap-1'>
                                    <Button className={`${isFavoriteLocation(locationDetail) ? 'btn-secondary' : 'btn-white'} rounded border-secondary border-2 heart-resp`} onClick={(event) => { favoriteLocation(event, locationDetail) }} style={{ border: "1px solid" }} aria-label="heart-icon">{HeartPlusIcon}</Button>
                                    <Button className=' w-100 btn-grey-light  rounded text-bold' onClick={() => { openInNewTab(locationDetail.website) }}>View Website</Button>
                                </div>
                            </div>

                            {ADSENSE.ENABLE ? <Adsense googleAdCenter slotId={ADSENSE.ITEM_VIEW.slotId} /> : ""}
                            
                        </Col>
                        <Col xs={12} sm={12} md={8} lg={9} className='list-section'>
                            { pageLoading ? null : <SaleListHoc props={props} type={SALE_LIST_TYPE.ESTATESALEFORLOCATION} locationDetail={locationDetail} /> }
                        </Col>
                    </div>
                    <div>
                        {ADSENSE.ENABLE ? <Adsense googleAdCenter slotId={ADSENSE.FOOTER.slotId} /> : ""}
                    </div>
                </div>
            }
        </div>
    )
};

export default SalesListForLocation;